import React from "react";
import { BsFileText } from "react-icons/bs";
import { FormattedMessage } from "react-intl";

import { Attachment } from "lib/build/attachments";

import { AttachmentTable } from "src/common/components/AttachmentTable";
import {
	Card,
	CardActions,
	CardContent,
	CardHeader,
	CardTitle
} from "src/common/components/Card";
import { Popover } from "src/common/components/Popover";
import { genericMessages } from "src/messages/generic";

import "./Section.css";

interface SectionProps {
	title: React.ReactNode;
	attachments?: Attachment[];
}

export const Section: React.FunctionComponent<
	React.PropsWithChildren<SectionProps>
> = ({ title, attachments, children }) => (
	<Card className="dashboard-section">
		<CardHeader>
			<CardTitle>{title}</CardTitle>
			<CardActions>
				{attachments && attachments.length > 0 && (
					<Popover
						target={
							<>
								<FormattedMessage
									{...genericMessages.allAttachments}
								/>
								<BsFileText />
							</>
						}
						content={<AttachmentTable attachments={attachments} />}
					/>
				)}
			</CardActions>
		</CardHeader>
		<CardContent>{children}</CardContent>
	</Card>
);
